module.exports = __webpack_public_path__ + "img/sbzzupanija.78ad5749.png";